import { useEffect, useState } from 'react';
import { fetchTransformTextList } from '@/services/text';
import { type ITransformTextItem } from '@/services/text/index.d';

let shapeListCache: any[] = [];

type ShapeTextItem = ITransformTextItem & {
    thumbnail: { url: string; width: number; height: number };
    thumbnail_black: any;
    corner_mark: any;
};

export const useShapeTextData = () => {
    const [list, setList] = useState<ShapeTextItem[]>([]);

    useEffect(() => {
        if (shapeListCache.length === 0) {
            fetchTransformTextList().then((res) => {
                shapeListCache = (res.data.response?.materials || []).map((el: ITransformTextItem) => {
                    return {
                        ...el,
                        thumbnail: { url: el.thumbnail, width: 0, height: 0 },
                        thumbnail_black: { url: '', width: 0, height: 0 },
                    };
                });
                setList(shapeListCache);
            });
        } else {
            setList(shapeListCache);
        }
    }, []);

    return list;
};
